import {useEffect} from "react";
import {useViewerStore} from "../../../store/store";
import { AlertType } from "../../../@types/enums";

type MessageAlertProps = {
    message: string,
    messageType: any,
    setState: any
}

const MessageAlert = (props: MessageAlertProps) => {

    const {message, messageType, setState} = props;
    const sceneViewer = useViewerStore(state => state.sceneViewer);
    const viewerAlert = useViewerStore(state => state.viewerAlert);

    useEffect(() => {
        const toastElement = document.getElementById("three-js-toast");
        if(!toastElement) return;

        const removeClasses = () => {
            toastElement.classList.remove(
                ...[
                    "ma-three-positive",
                    "ma-three-negative",
                    "ma-three-warning-message",
                    "ma-three-info",
                ]
            );
        };

        removeClasses();

        switch (messageType) {
            case AlertType.success:
                toastElement.classList.add("ma-three-positive");
                break;
            case AlertType.error:
                toastElement.classList.add("ma-three-negative");
                break;
            case AlertType.warning:
                toastElement.classList.add("ma-three-warning-message");
                break;
            case AlertType.info:
                toastElement.classList.add("ma-three-info");
                break;
            default:
                toastElement.classList.add("ma-three-info");
                break;
        }
    }, [viewerAlert]);

    const closeThreeJSAlert = () => {
        sceneViewer.removeViewerAlert()
        setState(false);
    };

    useEffect(() => {
        setTimeout(closeThreeJSAlert, 6000);
    }, []);

    return (
        <div
            id={"three-js-toast"}
            className={`alert ${viewerAlert && "open"} three-warning`}
        >
            <p className="alert__content-message">{message}</p>
        </div>
    );
};

export default MessageAlert;